import './Card.css'

/**
 * Surface used for page panels.
 * @param {string} [title]     optional heading shown in the card header
 * @param {string} [subtitle]  the scope the panel is drawn over ("لكل الفترات"),
 *                             which a chart card needs so a rate is never read
 *                             against the wrong period
 * @param {ReactNode} [footer] optional action bar pinned to the card bottom
 * @param {boolean} [flat]     drop the border, radius and shadow when the card is
 *                             embedded in a surface that already provides them
 */
export default function Card({ title, subtitle, footer, flat = false, className = '', children }) {
  return (
    <section className={`card${flat ? ' card--flat' : ''} ${className}`.trim()}>
      {title && (
        <header className="card__header">
          <h3 className="card__title">
            <bdi>{title}</bdi>
          </h3>
          {subtitle && (
            <p className="card__subtitle">
              <bdi>{subtitle}</bdi>
            </p>
          )}
          <div className="card__rule" aria-hidden="true" />
        </header>
      )}
      {children && <div className="card__body">{children}</div>}
      {footer && <footer className="card__footer">{footer}</footer>}
    </section>
  )
}
